import { ContactData } from '@/entities/ContactData';
import { Diamond } from '@/entities/Diamond';

export class DiamondListModel {
  headerText!: Nullable<string>;
  ownerText!: Nullable<string>;
  contactData?: Nullable<ContactData>;
  reports!: Diamond[];
}

export class DiamondListShortModel {
  headerText!: Nullable<string>;
  ownerText!: Nullable<string>;
  contactData?: Nullable<ContactData>;
  reports!: { id: number }[];
}

export class DiamondsList extends DiamondListModel {
  constructor(modelData: DiamondListModel) {
    super();

    Object.keys(modelData).forEach((key) => {
      switch (key) {
        case 'contactData':
          if (modelData['contactData']) {
            this[key] = new ContactData(modelData['contactData']);
          }

          break;
        case 'reports':
          this[key] = modelData[key].map((diamond) => new Diamond(diamond));

          break;
        default:
          this[key] = modelData[key];
      }
    });
  }
}
